import type { SearchPageState } from "../redux/types";
import { type SearchProductDataDTO } from "../models/SearchResultsDTO";
import { resolveApiUrl } from "~/utils/url/urlResolver";
import { getSearchEndpointParams } from "~/features/search/api/fetchSearchResults";

const url = resolveApiUrl("/api/salescampaign/search");

export async function fetchRecommendedProductsSearch(state: SearchPageState): Promise<SearchProductDataDTO[]> {
  const searchParams = getSearchEndpointParams(state);

  const response = await fetch(url + "?" + searchParams.toString(), {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });

  if (response.redirected) {
    window.location.reload();
  }

  if (!response.ok) {
    throw new Error("failed to fetch recommendations");
  }

  return response.json();
}
